import { render } from "./editCategory.vue?vue&type=template&id=dd04a920&scoped=true"
import script from "./editCategory.vue?vue&type=script&lang=js"
export * from "./editCategory.vue?vue&type=script&lang=js"

import "./editCategory.vue?vue&type=style&index=0&id=dd04a920&scoped=true&lang=css"

import exportComponent from "D:\\zhang\\项目\\经皮黄疸仪\\jaundiceweb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd04a920"]])

export default __exports__